var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Mixins, Watch } from 'vue-property-decorator';
import { lazyInject } from '@/dependency-injection';
import { TYPES } from '@/dependency-injection/types';
import { CarrierGroupService } from '@/services/carrier-management/carrier-group-service';
import { CarrierService } from '@/services/carrier-management/carrier-service';
import PromptDialogMixin from '@/mixins/prompt-dialog-mixin';
import SnackbarMixin from '@/mixins/snackbar-mixin';
import ItemsMixin from '@/mixins/items-mixin';
var ManageGroupRestorePrompt = /** @class */ (function (_super) {
    __extends(ManageGroupRestorePrompt, _super);
    function ManageGroupRestorePrompt() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // tree view for restoring
        _this.restoringItem = [];
        _this.carrierGroup = {};
        _this.itemsToBeRestored = [];
        return _this;
    }
    ManageGroupRestorePrompt.prototype.close = function () {
        this.restoringItem = [];
        this.itemsToBeRestored = [];
        this.closeRestoreDialog();
    };
    ManageGroupRestorePrompt.prototype.getRestoreDetails = function (val, oldVal) {
        return __awaiter(this, void 0, void 0, function () {
            var response, carrierGroupToRestore, error_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (oldVal !== val && val === false) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.carrierGroupservice.getById(this.selectedItem.id, 'getcarriergroupbyid')];
                    case 2:
                        response = _a.sent();
                        if (response.success === false) {
                            throw Error(response.message);
                        }
                        // save the carrier group
                        this.carrierGroup = response.data;
                        carrierGroupToRestore = response.data;
                        this.restoringItem = [
                            {
                                id: "" + this.carrierService.carrierGroupPrefix + carrierGroupToRestore.id,
                                name: carrierGroupToRestore.name,
                                children: carrierGroupToRestore.carriers
                                    .filter(function (carrier) { return carrier.id; })
                                    .map(function (carrier) {
                                    return ({
                                        id: "" + _this.carrierService.carrierPrefix + carrier.id,
                                        name: carrier.name,
                                        children: carrier.desks
                                            .filter(function (desk) { return desk.id; })
                                            .map(function (desk) {
                                            return ({
                                                id: "" + _this.carrierService.dispatchDeskPrefix + desk.id,
                                                name: desk.id + " - " + desk.name,
                                            });
                                        }),
                                    });
                                }),
                            },
                        ];
                        // reset any previously selected items
                        this.itemsToBeRestored = [];
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.error(error_1);
                        this.showSnackbar({
                            text: 'Unable to get details for carrier group',
                            color: 'error',
                        });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ManageGroupRestorePrompt.prototype.restoreCarrierGroup = function () {
        return __awaiter(this, void 0, void 0, function () {
            var selectedUnflattenedCarriers_1, carrierGroupRootNode, result, item, error_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        selectedUnflattenedCarriers_1 = this.carrierService.unFlattenCarriersCollection(this.itemsToBeRestored);
                        // add the carrier group id if they did not select it
                        if (selectedUnflattenedCarriers_1.groups.length === 0) {
                            selectedUnflattenedCarriers_1.groups.push(this.selectedItem.id);
                        }
                        carrierGroupRootNode = this.restoringItem[0];
                        selectedUnflattenedCarriers_1.desks.forEach(function (desk) {
                            // get matching parent
                            var matchingParent = _this.carrierGroup.carriers.filter(function (c) {
                                return c.desks.find(function (d) { return d.id === desk; });
                            });
                            // if no matching parent then return
                            if (matchingParent.length === 0) {
                                return;
                            }
                            // store the parent id
                            var parentId = matchingParent[0].id;
                            // see if parent id is in list of carriers to restore
                            var existingParentsMatch = selectedUnflattenedCarriers_1.carriers.filter(function (c) {
                                return c === parentId;
                            });
                            // if no match then add to collection
                            if (existingParentsMatch.length === 0) {
                                selectedUnflattenedCarriers_1.carriers.push(parentId);
                            }
                        });
                        return [4 /*yield*/, this.carrierGroupservice.restore(selectedUnflattenedCarriers_1)];
                    case 1:
                        result = _a.sent();
                        if (result.success && result.data) {
                            item = __assign({}, this.selectedItem);
                            item.isDeleted = false;
                            this.updateItemsCollection(item, ['id']);
                            this.showSnackbar({
                                text: "Restored " + item.name,
                                color: 'success',
                            });
                        }
                        else {
                            this.showSnackbar({ text: result.message, color: 'error' });
                        }
                        return [3 /*break*/, 4];
                    case 2:
                        error_2 = _a.sent();
                        console.error(error_2);
                        this.showSnackbar({
                            text: 'Unable to restore carrier group',
                            color: 'error',
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        // clear existing
                        this.restoringItem = [];
                        this.itemsToBeRestored = [];
                        this.closeRestoreDialog();
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    var _a, _b;
    __decorate([
        lazyInject(TYPES.CarrierGroupService),
        __metadata("design:type", typeof (_a = typeof CarrierGroupService !== "undefined" && CarrierGroupService) === "function" ? _a : Object)
    ], ManageGroupRestorePrompt.prototype, "carrierGroupservice", void 0);
    __decorate([
        lazyInject(TYPES.CarrierService),
        __metadata("design:type", typeof (_b = typeof CarrierService !== "undefined" && CarrierService) === "function" ? _b : Object)
    ], ManageGroupRestorePrompt.prototype, "carrierService", void 0);
    __decorate([
        Watch('restoreDialogVisible', { immediate: false, deep: false }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean, Boolean]),
        __metadata("design:returntype", Promise)
    ], ManageGroupRestorePrompt.prototype, "getRestoreDetails", null);
    ManageGroupRestorePrompt = __decorate([
        Component({})
    ], ManageGroupRestorePrompt);
    return ManageGroupRestorePrompt;
}(Mixins(PromptDialogMixin, SnackbarMixin, ItemsMixin)));
export default ManageGroupRestorePrompt;
